import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../lib/utils';
import { Section, type SectionProps } from './detail-panel';

/** Structured form section; inherits the existing heading/action convention and owns no scrolling. */
export function FormSection({ className, ...props }: SectionProps) {
  return <Section className={cn('@container/form', className)} {...props} />;
}

/** Columns depend on this grid's available width, including inside a desktop detail panel. */
export function FieldGrid({ columns = 2, className, children }: { columns?: 1 | 2 | 3; className?: string; children: ReactNode }) {
  return <div data-slot="field-grid" className={cn('@container/fields min-w-0', className)}>
    <div className={cn('grid min-w-0 grid-cols-1 gap-4', columns === 2 && '@md/fields:grid-cols-2', columns === 3 && '@md/fields:grid-cols-2 @3xl/fields:grid-cols-3')}>
      {children}
    </div>
  </div>;
}

export function FieldGridItem({ span, className, ...props }: ComponentProps<'div'> & { span?: 'full' }) {
  return <div className={cn('min-w-0', span === 'full' && 'col-span-full', className)} {...props} />;
}
